import { pushedBy, withMark, writeParam } from "@/lib/urlOverlay";

// The quote popup's place in the URL (BRK-S347): `?quote=<card key>` opens a
// carrier's popup over the cards. Opening pushes an entry, so the browser's
// (or a phone's) Back closes it, and a link opens it directly. URL state is
// the client state NN #9 allows. The rules are any URL overlay's
// (`useUrlOverlay`, BRK-S357).

export const QUOTE_PARAM = "quote";

/** The mark on an entry the popup pushed. */
export const QUOTE_MARK = "quotePopup";

/** A card key: its carrier's name as a slug. */
const CARD_KEY = /^[a-z0-9-]{1,80}$/;

/** The card the URL opens, or null. */
export function readQuotePopup(params: URLSearchParams): string | null {
  const key = params.get(QUOTE_PARAM);
  return key && CARD_KEY.test(key) ? key : null;
}

/** The search with the popup open on `key`, or closed, other params kept. */
export function writeQuotePopup(
  params: URLSearchParams,
  key: string | null,
): string {
  return writeParam(params, QUOTE_PARAM, key);
}

/** Whether the popup pushed this entry, so closing it goes back. */
export function pushedByPopup(state: unknown): boolean {
  return pushedBy(state, QUOTE_MARK);
}

/** An entry's state with the popup's mark. What the page was handed stays:
 *  the WC wizard hands its fan-out in it (BRK-S305). */
export function withPopupMark(state: unknown): Record<string, unknown> {
  return withMark(state, QUOTE_MARK);
}
